import { Modal, toast } from '@systemeio/ui'
import { ConnectInfoIntegration } from 'modules/profile/integrations/components/connect-info-integration'
import { ItemIntegration } from 'modules/profile/integrations/components/item-integration'
import { WrapperIntegration } from 'modules/profile/integrations/components/wrapper-integration'
import { WrapperIntegrationSkeleton } from 'modules/profile/integrations/components/wrapper-integtation-skeleton'
import { getHelpPageLinkZoom } from 'modules/profile/integrations/utils/get-help-page-link-zoom'
import { useIntegration } from 'modules/profile/integrations/zoom/hook/use-integration'
import { useIntegrations } from 'modules/profile/integrations/zoom/hook/use-integrations'
import React, { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { dateTimeFormat } from 'shared/utils/date-time-format'
import { ZoomIntegrationIcon } from '@systemeio/ui/icons'

export const ZoomIntegrationComingSoon = () => {
  const { t } = useLocoTranslation()
  return (
    <WrapperIntegration
      icon={<ZoomIntegrationIcon />}
      title={t('dashboard.user_settings.integrations_page.zoom_integration.name')}
      subTitle={t('dashboard.user_settings.integrations_page.zoom_integration.subtitle')}
      isComingSoon
    />
  )
}

export const ZoomIntegration = () => {
  const { user } = useUser()
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const { openZoomLogin, removeIntegration } = useIntegration({
    onError: handleIntegrationError,
    onSuccess: handleIntegrationSuccess,
    setIsLoading,
  })

  const { data, mutate } = useIntegrations()

  async function handleIntegrationSuccess() {
    await mutate()
  }

  async function handleIntegrationRemove() {
    try {
      setIsLoading(true)
      await removeIntegration()
      await mutate()
      setIsLoading(false)
      setOpened(false)
    } catch (e) {
      throw e
    }
  }

  function handleIntegrationError(error: Error) {
    toast.error(error.message)
  }

  function handleOpenModal() {
    setOpened(true)
  }

  async function handleOpenZoomLogin() {
    await openZoomLogin()
    setOpened(false)
  }

  async function handleRemoveZoomIntegration() {
    await handleIntegrationRemove()
    setOpened(false)
  }

  return (
    <>
      {data ? (
        <>
          <WrapperIntegration
            icon={<ZoomIntegrationIcon />}
            title={t('dashboard.user_settings.integrations_page.zoom_integration.name')}
            subTitle={t('dashboard.user_settings.integrations_page.zoom_integration.subtitle')}
            onClick={handleOpenModal}
            isConnect={data.items.length !== 0}
          />
          <Modal
            title={t('dashboard.user_settings.integrations_page.zoom_integration_title')}
            onClose={() => setOpened(false)}
            opened={opened}
            isFetching={isLoading}
          >
            <>
              {data.items.length !== 0 ? (
                data.items.map(item => (
                  <ItemIntegration
                    key={item.id}
                    email={item.email}
                    status={item.status && t('global.active')}
                    createdAt={dateTimeFormat(item.createdAt, {
                      timeFormat: user?.timeFormat,
                      dateFormat: user?.dateFormat,
                      timeZone: user?.timezone,
                    })}
                    removeIntegration={handleRemoveZoomIntegration}
                  />
                ))
              ) : (
                <ConnectInfoIntegration
                  isFetching={isLoading}
                  href={getHelpPageLinkZoom(user?.dashboardLocale)}
                  handleOpenIntegrationLogin={handleOpenZoomLogin}
                  infoText={'dashboard.user_settings.integrations_page.zoom_integration_help'}
                />
              )}
            </>
          </Modal>
        </>
      ) : (
        <WrapperIntegrationSkeleton />
      )}
    </>
  )
}
